// src/components/PrintOrder.js

import {
  getUnitPrice,
  calculateItemTotal,
  calculateCartTotal,
} from "../../helpers/cartPriceHelper";
import { calculateOrderDiscountSummary } from "../../helpers/orderDiscountHelper";

const translateOptionType = (type) => {
  switch (type) {
    case "Color":
      return "צבע";
    case "Size":
      return "מידה";
    default:
      return type;
  }
};

export const printOrder = (order, resolveImgSrc) => {
  if (!order) return;

  const products = order.ordersProducts || [];
  const productsPerPage = 18;
  const discountSummary = calculateOrderDiscountSummary(order);
  const shippingCost =
    Number(order?.shippingCost || 0);

  const finalTotalWithShipping =
    Number(discountSummary?.finalTotal || 0) +
    shippingCost;

  //   const address = order.user?.userAddresses?.[0];

  // const shortAddress = address
  //   ? [
  //       address.city,
  //       `${address.street || ""} ${address.houseNumber || ""}`.trim(),
  //     ]
  //       .filter(Boolean)
  //       .join(", ")
  //   : "לא צוין";

  const shortAddress = order.shippingAddress || "לא צוין";

  // מחלקים ל"עמודים" בני 20 מוצרים
  const pages = [];
  for (let i = 0; i < products.length; i += productsPerPage) {
    pages.push(products.slice(i, i + productsPerPage));
  }

  const printWindow = window.open("", "", "width=900,height=650");

  if (!printWindow) {
    alert("הדפדפן חסם את חלון ההדפסה. צריך לאפשר חלונות קופצים לאתר.");
    return;
  }

  printWindow.document.write(`
    <html dir="rtl">
      <head>
        <title>הדפסת הזמנה ${order.id}</title>

        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
          h2 { margin-bottom: 10px; }
          .section-title { font-weight: bold; margin-top: 20px; font-size: 18px; }

          .page { page-break-after: always; }
          .page:last-child { page-break-after: auto; }

          .products-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
            margin-top: 10px;
          }

         


          .product-item {
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 4px;
  font-size: 14px;

  display: flex;              /* ← חשוב */
  align-items: flex-start;
  gap: 10px;
}

.product-item img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;             /* ← שלא יתכווץ */
}

.product-content {
  flex: 1;                    /* ← הטקסט תופס את כל השורה */
}


          .customer-box {
            margin-top: 25px;
            padding: 15px;
            border: 1px solid #999;
            border-radius: 6px;
          }
.total-box {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #999;
  border-radius: 6px;
  font-size: 16px;
  text-align: right;

  break-inside: avoid;
  page-break-inside: avoid;
}

.total-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.total-row {
  margin-bottom: 6px;
}

.total-divider {
  border-top: 1px solid #999;
  margin: 10px 0;
}

.final-total {
  font-size: 19px;
  font-weight: bold;
}
            .customer-box {
  margin-top: 15px;
  padding: 12px;
  border: 1px solid #999;
  border-radius: 6px;

  display: flex;              /* ← הכל בשורה אחת */
  flex-wrap: wrap;            /* אם אין מקום – ירד שורה יפה */
  gap: 20px;

  font-size: 14px;

  break-inside: avoid;
  page-break-inside: avoid;
}

.customer-item {
  white-space: nowrap;        /* שלא יישבר באמצע */
}

        </style>
      </head>

      <body>
        ${pages
      .map(
        (pageProducts, index) => `
      <div class="page">
        
        <h2>פרטי הזמנה #${order.id} – עמוד ${index + 1}</h2>

        ${index === 0
            ? `
            <div class="order-date">
      <strong>תאריך הזמנה:</strong>
      ${order.date
              ? new Date(order.date).toLocaleDateString("he-IL")
              : "לא צוין"
            }
    </div>
         <div class="customer-box">
  <div class="customer-item"><strong>שם:</strong> ${order.user?.name ?? "לא צוין"}</div>
  <div class="customer-item"><strong>אימייל:</strong> ${order.user?.email ?? "לא צוין"}</div>
  <div class="customer-item"><strong>טלפון:</strong> ${order.user?.phone ?? "לא צוין"}</div>
 <div class="customer-item"><strong>שיטת משלוח:</strong> ${order.shippingMethod ?? "לא צוין"}</div>
  <div class="customer-item"><strong>כתובת:</strong> ${shortAddress}</div>
</div>

        `
            : ""
          }

        <div class="section-title">מוצרים:</div>

        <div class="products-grid">
      ${pageProducts
            .map((p) => {
              const optionText = p.productOption
                ? ` (${translateOptionType(p.productOption.optionType)}: ${p.productOption.value})`
                : "";

              const unitPrice = getUnitPrice(p);
              const amount = Number(p.amount) || 0;
              const lineTotal = calculateItemTotal(p);

              return `
  <div class="product-item">
    <img src="${resolveImgSrc(p.product.image)}" />

    <div class="product-content">
      <strong>${p.product.name}${optionText}</strong><br>
      כמות: ${amount}<br>
      מחיר ליחידה: ${unitPrice.toFixed(2)} ₪<br>
      סה"כ: ${lineTotal.toFixed(2)} ₪
    </div>
  </div>
`;
            })

            .join("")}


        </div>

        ${index === pages.length - 1
            ? `
    <div class="total-box">

      <div class="total-title">
        סיכום מחיר
      </div>

      <div class="total-row">
        מחיר מוצרים:
        ${Number(discountSummary?.subtotal || 0).toFixed(2)} ₪
      </div>

      ${Number(discountSummary?.discountAmount || 0) > 0
              ? `
            <div class="total-row">
              הנחת לקוח ${Number(
                discountSummary?.discountPercent || 5
              )}%:
              ${Number(
                discountSummary.discountAmount
              ).toFixed(2)} ₪
            </div>
          `
              : ""
            }

      <div class="total-row">
        מחיר משלוח:
        ${shippingCost.toFixed(2)} ₪
      </div>

      <div class="total-divider"></div>

      <div class="final-total">
        סה"כ לתשלום:
        ${finalTotalWithShipping.toFixed(2)} ₪
      </div>

    </div>
  `
            : ""
          }

      </div>
    `
      )
      .join("")}

      </body>
    </html>
  `);

  printWindow.document.close();

  printWindow.onload = () => {
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();

      // לא לסגור מיד
      // printWindow.close();
    }, 700);
  };
};
